import { render } from "./QR-Tool.vue?vue&type=template&id=8dfd59a0&scoped=true"
import script from "./QR-Tool.vue?vue&type=script&lang=js"
export * from "./QR-Tool.vue?vue&type=script&lang=js"

import "./QR-Tool.vue?vue&type=style&index=0&id=8dfd59a0&scoped=true&lang=css"

import exportComponent from "E:\\goldtower\\project\\QR-TOOL\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfd59a0"]])

export default __exports__